import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/admin/academy/")({
  beforeLoad: () => {
    throw redirect({
      to: "/admin/academy/courses",
    });
  },
});
